import { render, staticRenderFns } from "./StatCount.vue?vue&type=template&id=498640f4&"
import script from "./StatCount.vue?vue&type=script&lang=js&"
export * from "./StatCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports